// plugins/vconsole.client.js
// import VConsole from 'vconsole';

export default defineNuxtPlugin((nuxtApp) => {
  // if (process.env.NODE_ENV === 'development') {
  //   // 确保只在客户端运行
  //   if (process.client) {
  //     new VConsole();
  //   }
  // }
});
